/* In by Dark size finder.
   Gildan Softstyle 64000 published height/weight bands (inclusive).
   A missing height max means no maximum. No XS, 5XL, or invented 3XL/4XL bands.
   3XL and 4XL are only reached by stepping up from 2XL when the fit is Oversized.
   Bella+Canvas 6004 starts from the women's bands and moves one label up,
   because that body is about 2 inches narrower than Gildan at the same label.
   Bella stops at 2XL. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== "undefined" && module.exports) {
    module.exports = api;
  }
  if (typeof document === "undefined") return;

  var GARMENTS = {
    gildan: {
      title: "Gildan Softstyle 64000",
      rows: [
        ["S", 18, 28],
        ["M", 20, 29],
        ["L", 22, 30],
        ["XL", 24, 31],
        ["2XL", 26, 32],
        ["3XL", 28, 33],
        ["4XL", 30, 34],
      ],
    },
    bella: {
      title: "Bella+Canvas 6004",
      rows: [
        ["S", 16, 26.25],
        ["M", 16.75, 26.75],
        ["L", 17.75, 27.375],
        ["XL", 18.75, 28],
        ["2XL", 19.75, 28.625],
      ],
    },
  };

  function canonicalSize(raw) {
    var label = String(raw || "")
      .trim()
      .toUpperCase()
      .replace(/\s+/g, "")
      .replace(/-/g, "");
    var map = {
      S: "S",
      SMALL: "S",
      M: "M",
      MED: "M",
      MEDIUM: "M",
      L: "L",
      LG: "L",
      LARGE: "L",
      XL: "XL",
      XLARGE: "XL",
      "2XL": "2XL",
      XXL: "2XL",
      "2X": "2XL",
      "3XL": "3XL",
      XXXL: "3XL",
      "3X": "3XL",
      "4XL": "4XL",
      XXXXL: "4XL",
      "4X": "4XL",
    };
    return map[label] || "";
  }

  function offeredSet(raw) {
    var set = {};
    String(raw || "")
      .split(",")
      .forEach(function (part) {
        var label = canonicalSize(part);
        if (label) set[label] = true;
      });
    return set;
  }

  function fitOf(rootEl) {
    var pressed = rootEl.querySelector("[data-bmp-fit-choice][aria-pressed='true']");
    return pressed ? pressed.getAttribute("data-bmp-fit-choice") : "relaxed";
  }

  function readNumber(input) {
    if (!input || input.value.trim() === "") return null;
    var value = Number(input.value);
    return Number.isFinite(value) ? value : null;
  }

  function blankOf(rootEl) {
    return rootEl.getAttribute("data-bmp-fit-blank") === "bella" ? "bella" : "gildan";
  }

  function currentBodyUnit(rootEl) {
    var pressed = rootEl.querySelector("[data-bmp-fit-unit][aria-pressed='true']");
    return pressed && pressed.getAttribute("data-bmp-fit-unit") === "metric" ? "metric" : "imperial";
  }

  function currentMeasureUnit(rootEl) {
    var pressed = rootEl.querySelector("[data-bmp-fit-measure-unit][aria-pressed='true']");
    return pressed && pressed.getAttribute("data-bmp-fit-measure-unit") === "cm" ? "cm" : "in";
  }

  function formatMeasure(inches, unit) {
    if (unit === "cm") return (Math.round(inches * 2.54 * 10) / 10).toFixed(1);
    return String(Math.round(inches * 1000) / 1000);
  }

  function message(result) {
    if (!result) return "";
    if (result.code === "outside-bands") {
      return "Your height and weight are outside the published bands, so there isn’t a size to suggest.";
    }
    if (result.code === "gap") {
      return "Your height and weight match published sizes more than one step apart, so there isn’t one size to suggest.";
    }
    if (result.code === "bella-past" || result.code === "past-ladder") {
      return "Your height and weight are outside the sizes this shirt offers.";
    }
    return "";
  }

  function renderResult(out, result, offered) {
    out.replaceChildren();
    if (!result || result.code !== "ok") {
      out.textContent = message(result);
      return;
    }
    if (Object.keys(offered).length && !offered[result.size]) {
      out.textContent = "Suggested size " + result.size + " is not offered on this shirt.";
      return;
    }
    var strong = document.createElement("strong");
    strong.className = "bmp-fit-finder__size";
    strong.textContent = result.size;
    out.appendChild(strong);
    if (result.capped) {
      var note = document.createElement("span");
      note.className = "bmp-fit-finder__note";
      note.textContent = "Oversized stays at 2XL, the largest size this shirt offers.";
      out.appendChild(note);
    }
  }

  function update(rootEl) {
    var out = rootEl.querySelector("[data-bmp-fit-result]");
    if (!out) return;
    var heightIn;
    var weightLb;
    if (currentBodyUnit(rootEl) === "metric") {
      var cm = readNumber(rootEl.querySelector("[data-bmp-fit-cm]"));
      var kg = readNumber(rootEl.querySelector("[data-bmp-fit-weight]"));
      if (cm === null || kg === null || cm <= 0 || kg <= 0) {
        out.replaceChildren();
        out.textContent = "Enter height and weight.";
        return;
      }
      heightIn = cm / 2.54;
      weightLb = kg * 2.20462;
    } else {
      var feet = readNumber(rootEl.querySelector("[data-bmp-fit-feet]"));
      var inches = readNumber(rootEl.querySelector("[data-bmp-fit-inches]"));
      var weight = readNumber(rootEl.querySelector("[data-bmp-fit-weight]"));
      if (feet === null || inches === null || weight === null) {
        out.replaceChildren();
        out.textContent = "Enter height and weight.";
        return;
      }
      if (inches < 0 || inches > 11 || Math.round(inches) !== inches) {
        out.replaceChildren();
        out.textContent = "Enter inches from 0 through 11.";
        return;
      }
      if (feet < 0 || Math.round(feet) !== feet) {
        out.replaceChildren();
        out.textContent = "Enter height in whole feet.";
        return;
      }
      heightIn = feet * 12 + inches;
      weightLb = weight;
    }
    var blank = blankOf(rootEl);
    var fit = fitOf(rootEl);
    var result = api.suggestSize({
      heightIn: heightIn,
      weightLb: weightLb,
      fit: fit,
      blank: blank,
    });
    result.fit = fit;
    renderResult(out, result, offeredSet(rootEl.getAttribute("data-bmp-fit-sizes")));
  }

  function setPressed(buttons, match) {
    buttons.forEach(function (button) {
      button.setAttribute("aria-pressed", match(button) ? "true" : "false");
    });
  }

  function convertBody(rootEl, fromUnit, toUnit) {
    var feetInput = rootEl.querySelector("[data-bmp-fit-feet]");
    var inchInput = rootEl.querySelector("[data-bmp-fit-inches]");
    var cmInput = rootEl.querySelector("[data-bmp-fit-cm]");
    var weightInput = rootEl.querySelector("[data-bmp-fit-weight]");
    if (fromUnit === "imperial" && toUnit === "metric") {
      var feet = readNumber(feetInput);
      var inches = readNumber(inchInput);
      var pounds = readNumber(weightInput);
      if (cmInput && feet !== null && inches !== null) {
        cmInput.value = (Math.round((feet * 12 + inches) * 2.54 * 10) / 10).toFixed(1);
      }
      if (weightInput && pounds !== null) {
        weightInput.value = String(Math.round((pounds / 2.20462) * 10) / 10);
      }
      return;
    }
    if (fromUnit === "metric" && toUnit === "imperial") {
      var cm = readNumber(cmInput);
      var kg = readNumber(weightInput);
      if (feetInput && inchInput && cm !== null) {
        var total = cm / 2.54;
        var wholeFeet = Math.floor(total / 12);
        var wholeInches = Math.round(total - wholeFeet * 12);
        if (wholeInches === 12) {
          wholeFeet += 1;
          wholeInches = 0;
        }
        feetInput.value = String(wholeFeet);
        inchInput.value = String(wholeInches);
      }
      if (weightInput && kg !== null) {
        weightInput.value = String(Math.round(kg * 2.20462));
      }
    }
  }

  function setBodyUnit(rootEl, unit) {
    var next = unit === "metric" ? "metric" : "imperial";
    var prev = currentBodyUnit(rootEl);
    if (prev !== next) convertBody(rootEl, prev, next);
    setPressed(rootEl.querySelectorAll("[data-bmp-fit-unit]"), function (button) {
      return button.getAttribute("data-bmp-fit-unit") === next;
    });
    var imperial = rootEl.querySelector("[data-bmp-fit-height-imperial]");
    var metric = rootEl.querySelector("[data-bmp-fit-height-metric]");
    if (imperial) imperial.hidden = next === "metric";
    if (metric) metric.hidden = next !== "metric";
    var weightUnit = rootEl.querySelector("[data-bmp-fit-weight-unit]");
    if (weightUnit) weightUnit.textContent = next === "metric" ? "kg" : "lb";
    var weightLabel = rootEl.querySelector("[data-bmp-fit-weight-label]");
    if (weightLabel) weightLabel.textContent = next === "metric" ? "Weight (kg)" : "Weight (lb)";
    var weight = rootEl.querySelector("[data-bmp-fit-weight]");
    if (weight) weight.step = next === "metric" ? "0.1" : "1";
  }

  function renderChart(rootEl) {
    var tbody = rootEl.querySelector("[data-bmp-fit-chart]");
    if (!tbody) return;
    var blank = blankOf(rootEl);
    var chart = GARMENTS[blank];
    var offered = offeredSet(rootEl.getAttribute("data-bmp-fit-sizes"));
    var hasOffered = Object.keys(offered).length > 0;
    var unit = currentMeasureUnit(rootEl);
    tbody.replaceChildren();
    chart.rows.forEach(function (row) {
      if (hasOffered && !offered[row[0]]) return;
      var tr = document.createElement("tr");
      [row[0], formatMeasure(row[1], unit), formatMeasure(row[2], unit)].forEach(function (text) {
        var td = document.createElement("td");
        td.textContent = text;
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
  }

  function setMode(rootEl, mode) {
    var compare = mode === "compare";
    setPressed(rootEl.querySelectorAll("[data-bmp-fit-mode]"), function (button) {
      return button.getAttribute("data-bmp-fit-mode") === (compare ? "compare" : "suggest");
    });
    var suggestPanel = rootEl.querySelector("[data-bmp-fit-panel='suggest']");
    var comparePanel = rootEl.querySelector("[data-bmp-fit-panel='compare']");
    if (suggestPanel) suggestPanel.hidden = compare;
    if (comparePanel) comparePanel.hidden = !compare;
    if (compare) renderChart(rootEl);
  }

  function onPointer(event) {
    if (!event.target.closest) return;
    var rootEl = event.target.closest("[data-bmp-fit-finder]");
    if (!rootEl) return;

    var mode = event.target.closest("[data-bmp-fit-mode]");
    if (mode && rootEl.contains(mode)) {
      event.preventDefault();
      setMode(rootEl, mode.getAttribute("data-bmp-fit-mode"));
      return;
    }

    var unit = event.target.closest("[data-bmp-fit-unit]");
    if (unit && rootEl.contains(unit)) {
      event.preventDefault();
      setBodyUnit(rootEl, unit.getAttribute("data-bmp-fit-unit"));
      return;
    }

    var choice = event.target.closest("[data-bmp-fit-choice]");
    if (choice && rootEl.contains(choice)) {
      event.preventDefault();
      rootEl.querySelectorAll("[data-bmp-fit-choice]").forEach(function (button) {
        button.setAttribute("aria-pressed", button === choice ? "true" : "false");
      });
      var shown = rootEl.querySelector("[data-bmp-fit-result]");
      if (shown && shown.textContent.trim()) update(rootEl);
      return;
    }

    var submit = event.target.closest("[data-bmp-fit-submit]");
    if (submit && rootEl.contains(submit)) {
      event.preventDefault();
      update(rootEl);
      return;
    }

    var explain = event.target.closest("[data-bmp-fit-explain]");
    if (explain && rootEl.contains(explain)) {
      event.preventDefault();
      var open = explain.getAttribute("aria-expanded") === "true";
      explain.setAttribute("aria-expanded", open ? "false" : "true");
      var copy = rootEl.querySelector("[data-bmp-fit-explain-copy]");
      if (copy) copy.hidden = open;
      return;
    }

    var measure = event.target.closest("[data-bmp-fit-measure-unit]");
    if (measure && rootEl.contains(measure)) {
      event.preventDefault();
      setPressed(rootEl.querySelectorAll("[data-bmp-fit-measure-unit]"), function (button) {
        return button === measure;
      });
      renderChart(rootEl);
      return;
    }

    var back = event.target.closest("[data-bmp-fit-back]");
    if (back && rootEl.contains(back)) {
      event.preventDefault();
      setMode(rootEl, "suggest");
    }
  }

  if (!root.__bmpFitFinderBound) {
    root.__bmpFitFinderBound = true;
    document.addEventListener("click", onPointer);
  }
})(typeof window !== "undefined" ? window : globalThis, function () {
  var ORDER = ["S", "M", "L", "XL", "2XL", "3XL", "4XL"];
  var GILDAN = [
    { who: "men", label: "S", hMin: 64, hMax: 68, wMin: 120, wMax: 140 },
    { who: "men", label: "M", hMin: 67, hMax: 71, wMin: 145, wMax: 165 },
    { who: "men", label: "L", hMin: 69, hMax: 73, wMin: 170, wMax: 190 },
    { who: "men", label: "XL", hMin: 71, hMax: 75, wMin: 195, wMax: 220 },
    { who: "men", label: "2XL", hMin: 73, hMax: null, wMin: 225, wMax: 250 },
    { who: "women", label: "S", hMin: 60, hMax: 64, wMin: 105, wMax: 125 },
    { who: "women", label: "M", hMin: 63, hMax: 67, wMin: 125, wMax: 145 },
    { who: "women", label: "L", hMin: 65, hMax: 69, wMin: 145, wMax: 170 },
    { who: "women", label: "XL", hMin: 66, hMax: 71, wMin: 170, wMax: 195 },
    { who: "women", label: "2XL", hMin: 67, hMax: null, wMin: 195, wMax: 225 },
  ];
  var BELLA_UP = { S: "M", M: "L", L: "XL", XL: "2XL", "2XL": null };

  function contains(value, min, max) {
    if (value < min) return false;
    if (max == null) return true;
    return value <= max;
  }

  // SanMar reprint of the Gildan 64000 body-chest chart, inches around the chest.
  var GILDAN_CHEST = [
    { label: "S", min: 36, max: 37 },
    { label: "M", min: 38, max: 40 },
    { label: "L", min: 42, max: 44 },
    { label: "XL", min: 46, max: 48 },
    { label: "2XL", min: 50, max: 52 },
    { label: "3XL", min: 54, max: 56 },
    { label: "4XL", min: 58, max: 60 }
  ];

  function estimateChest(heightIn, weightLb) {
    return 36 + (weightLb - 130) * 0.117 - (heightIn - 66) * 0.12;
  }

  function suggestGildan(input, fit) {
    var chest = estimateChest(input.heightIn, input.weightLb);
    var labels = [];
    GILDAN_CHEST.forEach(function (band) {
      if (chest >= band.min && chest <= band.max) labels.push(band.label);
    });
    if (!labels.length) {
      for (var i = 0; i < GILDAN_CHEST.length - 1; i++) {
        var left = GILDAN_CHEST[i];
        var right = GILDAN_CHEST[i + 1];
        if (chest > left.max && chest < right.min) {
          labels.push(left.label, right.label);
          break;
        }
      }
    }
    if (!labels.length) {
      if (chest < 36 && chest >= 33) labels.push("S");
      else if (chest > 60 && chest <= 63) labels.push("4XL");
      else return { code: "outside-bands" };
    }
    return finish(labels, fit, ORDER.indexOf("4XL"));
  }

  function finish(labels, fit, cap) {
    var indexes = [];
    labels.forEach(function (label) {
      var index = ORDER.indexOf(label);
      if (index >= 0 && indexes.indexOf(index) === -1) indexes.push(index);
    });
    var minI = Math.min.apply(null, indexes);
    var maxI = Math.max.apply(null, indexes);
    if (maxI - minI > 1) return { code: "gap" };
    var chosenI = fit === "closer" ? minI : maxI;
    var capped = false;
    if (fit === "oversized") {
      if (maxI + 1 > cap) {
        if (cap === ORDER.indexOf("4XL")) return { code: "past-ladder" };
        chosenI = cap;
        capped = true;
      } else {
        chosenI = maxI + 1;
      }
    }
    return { code: "ok", size: ORDER[chosenI], capped: capped, fit: fit };
  }

  function suggestSize(input) {
    var blank = input.blank === "bella" ? "bella" : "gildan";
    var fit = input.fit === "closer" || input.fit === "oversized" ? input.fit : "relaxed";
    if (blank !== "bella") return suggestGildan(input, fit);
    var pool = GILDAN.filter(function (band) {
      return blank !== "bella" || band.who === "women";
    });
    var matched = pool.filter(function (band) {
      return contains(input.heightIn, band.hMin, band.hMax) && contains(input.weightLb, band.wMin, band.wMax);
    });
    if (!matched.length) {
      function bandDistance(band) {
        var height = 0;
        var weight = 0;
        if (input.heightIn < band.hMin) height = band.hMin - input.heightIn;
        else if (band.hMax != null && input.heightIn > band.hMax) height = input.heightIn - band.hMax;
        if (input.weightLb < band.wMin) weight = band.wMin - input.weightLb;
        else if (input.weightLb > band.wMax) weight = input.weightLb - band.wMax;
        return height + weight / 5;
      }
      var scored = pool.map(function (band) {
        return { band: band, score: bandDistance(band) };
      });
      var best = Math.min.apply(null, scored.map(function (row) { return row.score; }));
      if (!(best <= 6)) return { code: "outside-bands" };
      matched = scored.filter(function (row) {
        return row.score <= best + 2;
      }).map(function (row) { return row.band; });
    }

    var labels = matched.map(function (band) {
      return band.label;
    });
    if (blank === "bella") {
      var shifted = [];
      labels.forEach(function (label) {
        var next = BELLA_UP[label];
        if (next) shifted.push(next);
      });
      if (!shifted.length) return { code: "bella-past" };
      labels = shifted;
    }

    return finish(labels, fit, ORDER.indexOf("2XL"));
  }

  return { ORDER: ORDER, GILDAN: GILDAN, suggestSize: suggestSize };
});
